module.exports = __webpack_public_path__ + "static/lunker_card-ded6da8e4dffbfaa146c2a8b916000c0.png";